import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// routes
import { PATH_DASHBOARD } from 'routes/paths';

// hooks
import useAuth from 'hooks/useAuth';
// pages
import Login from 'pages/auth/Login';
// components
import LoadingScreen from 'components/LoadingScreen';
import RoleBasedGuard from './RoleBasedGuard';

// ----------------------------------------------------------------------

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized, permissions, isPrivateTheme } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);
  const PATIENT_PERMISSION = permissions?.findIndex(item => item.functioncode === "LSTDEMANDE") !== -1; // ok
  const MESSAGES_PERMISSION = permissions?.findIndex(item => item.functioncode === "ENCOURS") !== -1; // ok
  const ACCOUNT_PERMISSION = permissions?.findIndex(item => item.functioncode === "MONCOMPTE") !== -1;  // ok
  const DELEGATION_PERMISSION = permissions?.findIndex(item => item.functioncode === "DELEGATION") !== -1; // ok
  const HISTORY_PERMISSION = permissions?.findIndex(item => item.functioncode === "DEMANDES") !== -1; // ok
  const ASSOCIATION_PERMISSION = permissions?.findIndex(item => item.functioncode === "ASSOC") !== -1; // ok
  const FUSION_PERMISSION = permissions?.findIndex(item => item.functioncode === "FUSION") !== -1; // ok
  const PARAMETER_PERMISSION = permissions?.findIndex(item => item.functioncode === "PARAM") !== -1; // ok
  const PPROFILE_PERMISSION = permissions?.findIndex(item => item.functioncode === "PROFILE") !== -1; // ok
  const USER_PERMISSION = permissions?.findIndex(item => item.functioncode === "USER") !== -1; // ok
  const GROUP_EXAM_PERMISSION = permissions?.findIndex(item => item.functioncode === "FILTRE") !== -1; // ok 
  const ACTEURS_PERMISSION = permissions?.findIndex(item => item.functioncode === "UF") !== -1; // ok 
  const DICO_PERMISSION = permissions?.findIndex(item => item.functioncode === "DICO") !== -1; // ok 
  const PREFERENCES_PERMISSION = permissions?.findIndex(item => item.functioncode === "USERPREF") !== -1; // ok 

  const checkPermission = [
    { path: PATH_DASHBOARD.home.app, show: true },
    { path: PATH_DASHBOARD.root, show: true },
    { path: PATH_DASHBOARD.demandes.list, show: PATIENT_PERMISSION },
    { path: PATH_DASHBOARD.message.list, show: MESSAGES_PERMISSION },
    { path: PATH_DASHBOARD.account.edit, show: ACCOUNT_PERMISSION },
    { path: PATH_DASHBOARD.preferences.edit, show: PREFERENCES_PERMISSION },
    { path: PATH_DASHBOARD.delegation.list, show: DELEGATION_PERMISSION },
    { path: PATH_DASHBOARD.consultation.list, show: HISTORY_PERMISSION },
    { path: PATH_DASHBOARD.association.list, show: ASSOCIATION_PERMISSION },
    { path: PATH_DASHBOARD.fusion.list, show: FUSION_PERMISSION },
    { path: PATH_DASHBOARD.setting.edit, show: PARAMETER_PERMISSION },
    { path: PATH_DASHBOARD.profile.list, show: PPROFILE_PERMISSION },
    { path: PATH_DASHBOARD.profile.add, show: PPROFILE_PERMISSION },
    { path: PATH_DASHBOARD.user.list, show: USER_PERMISSION },
    { path: PATH_DASHBOARD.user.add, show: USER_PERMISSION },
    { path: PATH_DASHBOARD.groups.list, show: GROUP_EXAM_PERMISSION },
    { path: PATH_DASHBOARD.groups.add, show: GROUP_EXAM_PERMISSION },
    { path: PATH_DASHBOARD.actor.list, show: ACTEURS_PERMISSION },
    { path: PATH_DASHBOARD.actor.add, show: ACTEURS_PERMISSION },
    { path: PATH_DASHBOARD.dictionary.add, show: DICO_PERMISSION },
    { path: PATH_DASHBOARD.dictionary.list, show: DICO_PERMISSION }
  ];
  const hasNotPermission = pathname !== PATH_DASHBOARD.root && checkPermission?.findIndex((item) => pathname.includes(item.path) && item.path !== PATH_DASHBOARD.root && item.show) === -1;

  if (hasNotPermission)
    return <Navigate to={PATH_DASHBOARD.home.app} />;

  if (isPrivateTheme)
    return <RoleBasedGuard />;

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
